import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { gsap } from 'gsap'; // Importa gsap

// Define un componente estilizado para una imagen en la galería.
const GalleryImage = styled.img`
  width: 100%;
  height: auto;
`;

// Define un componente funcional LazyGalleryImage que implementa la carga perezosa de imágenes.
const LazyGalleryImage = ({ src, alt, onClick, style }) => {
  const [isVisible, setIsVisible] = useState(false);
  const imageRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    if (imageRef.current) observer.observe(imageRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isVisible && imageRef.current) {
      gsap.fromTo(
        imageRef.current,
        { opacity: 0 },
        { opacity: 1, duration: 1, delay: 0.2 } // Reduced delay for better feel
      );
    }
  }, [isVisible]);

  return (
    // We keep the ref on the container for the observer
    <div ref={imageRef} style={{ width: '100%', height: '100%' }}>
      {isVisible ? (
        <GalleryImage
          // Trigger the onClick passed from CargaImagenes
          onClick={onClick}
          style={{ opacity: 1, ...style }}
          src={src}
          alt={alt}
        />
      ) : (
        <div style={{ height: '400px', backgroundColor: '#f0f0f0' }}></div>
      )}
    </div>
  );
};

//----------------------------------------------------------------------------------------------------

export { LazyGalleryImage };
